<ng-container *transloco="let t">
  <div [class.admin-template]="isAdmin">
    @if ((showEmptyState || competitorViewData.length > 0) && viewDataHelper) {
      @if (showHeader) {
        <div>
          <app-races-header [cssClass]="'small'" [defaultLanguage]="event?.defaultLanguage" [isAdmin]="isAdmin"
                            [languages]="languages" [race]="race" [showExportButton]="false"
                            [showName]="true"></app-races-header>
        </div>
      }
      @if (filteringEnabled) {
        @if (isAdmin) {
          <!-- Filter part for admin -->

        <div class="filter-wrapper">
          <div class="d-flex flex-column flex-lg-row justify-content-lg-end">
            <ng-content select="[slot='competitorTableAdminTrailingWidgets']"></ng-content>
          </div>
          @if (activeRaceFilterGroups || activeFilterGroups) {
            <div class="pb-3">
                <app-filter-panel
                        [groups]="((activeRaceFilterGroups ?? activeFilterGroups) | mapToArray)"
                        [showFilterChips]="false"
                        [minTextSearchLength]="isAdmin ? MIN_SEARCH_INPUT_LENGTH_ADMIN : MIN_SEARCH_INPUT_LENGTH "
                        (filterChange)="onFilterChange($event)"
                >
                <div slot="filterTrailing">
                  <app-competitor-count [raceId]="race?.id" [event]="event"
                                        [displayCount]="measurements ? ['total',  'withStartNumber', 'started', 'finished', 'disqualified', 'didNotFinished'] : ['total', 'paidOrConfirmedCount', 'withStartNumber']"/>

                </div>
                </app-filter-panel>
            </div>
          }
        </div>
        } @else {
          <!-- Filter part for public-->
          @if (activeRaceFilterGroups || activeFilterGroups) {
            <app-filter-panel
                    [groups]="((activeRaceFilterGroups ?? activeFilterGroups) | mapToArray)"
                    [minTextSearchLength]="isAdmin ? MIN_SEARCH_INPUT_LENGTH_ADMIN : MIN_SEARCH_INPUT_LENGTH"
                    [showFilterChips]="false"
                    (filterChange)="onFilterChange($event)"
            />
          }
        }
      }
      <div class="table-responsive competitor-table" [ngClass]="{'pt-16 mb-16': showHeader}">
        @if (competitorViewData.length > 0) {
          <div>
            <div infinite-scroll
                 [infiniteScrollDistance]="2"
                 (scrolled)="loadMore()">

              <!--              Mobile list item-->
              <div class="d-flex flex-column d-flex d-lg-none">
                @for (competitor of competitorViewData;track competitor;let idx = $index;let last = $last) {
                  <ng-container *ngTemplateOutlet="competitorMobileItem; context: {
                  competitor: competitor,
                  isAdmin: isAdmin,
                  last: last
                }"></ng-container>
                }
              </div>

              <div class="d-flex">
                <div class="flex-grow-1" style="overflow-x: auto;">
                  <div class="d-none d-lg-flex">
                    <app-sortable-table [cssClass]="'table align-middle header'" [items]="competitorViewData"
                                        (onSort)="sortCompetitors()">
                      <thead class="table-header">
                      <tr>
                          @for (kv of (currentViewData?.options | keyvalue:keepOriginalOrder); track kv.key) {
                          @if (kv.value.selected && kv.value.isGeneral) {
                          <th scope="col" [sortBy]="[kv.key]"
                              [attr.data-type]="(kv.key === 'identityCardExpires' || kv.key === 'startTime' || kv.key === 'birthday' || kv.key === 'created' || kv.key === 'modified') ? 'date' : '' "
                              [ngClass]="assignClass(kv.key)">
                              <div class="d-flex align-items-end justify-content-start">
                                  <div class="col-name-holder">
                                      {{t('competitor.table.' + kv.key)}}
                                  </div>
                                  <div class="icon-holder"></div>
                              </div>
                          </th>
                          }
                          }
                          @for (kv of (currentViewData?.options | keyvalue:keepOriginalOrder); track kv.key) {
                          @if (kv.value.selected && kv.value.isCustom) {
                          <th scope="col">
                              <div class="d-flex align-items-end justify-content-start">
                                  <div class="col-name-holder">
                                      {{kv.value.label}}
                                  </div>
                                  <div class="icon-holder"></div>
                              </div>
                          </th>
                          }
                          }
                          @for (kv of (currentViewData?.options | keyvalue:keepOriginalOrder); track kv.key) {
                          @if (kv.value.selected && kv.value.isPricing) {
                          <th scope="col">
                              <div class="d-flex align-items-end justify-content-start">
                                  <div class="col-name-holder">
                                      {{kv.value.label}}
                                  </div>
                                  <div class="icon-holder"></div>
                              </div>
                          </th>
                          }
                          }
                      </tr>
                      </thead>
                      @if (isAdmin) {
                        <tr app-table-header-separator></tr>
                      }
                      <tbody #tbody>

                        @for (competitor of competitorViewData;track competitor.id;let idx = $index) {
                          <tr [class.clickable]="isAdmin" [ngStyle]="$last ? {'border-color': 'transparent'} : {}">

                        @for (kv of (currentViewData?.options | keyvalue:keepOriginalOrder); track kv.key) {
                            @if (kv.value.selected && kv.value.isGeneral) {
                              <td class="center-align">
                                    <span class="text-truncate fs-15">
                                       <app-competitor-field-output
                                        [competitor]="competitor"
                                        [key]="kv.key" [isAdmin]="isAdmin"
                                         [fieldType]="'general'"
                                         [showAsPlain]="false"
                                         [showTooltip]="true"/>
                                    </span>
                              </td>
                            }
                        }
                        @for (kv of (currentViewData?.options | keyvalue: keepOriginalOrder); track kv.key) {
                            @if (kv.value.selected && kv.value.isCustom) {
                            <td class="center-align">
                                <span class="text-nowrap">
                                       <app-competitor-field-output
                                        [competitor]="competitor" [isAdmin]="isAdmin"
                                        [key]="kv.key"
                                        [showTooltip]="true"
                                        [fieldType]="'custom'"/>
                                </span>
                            </td>
                            }
                        }
                        @for (kv of (currentViewData?.options | keyvalue:keepOriginalOrder); track kv.key) {
                            @if (kv.value.selected && kv.value.isPricing) {
                            <td class="center-align">
                                 <span class="text-nowrap">
                                       <app-competitor-field-output
                                        [competitor]="competitor" [isAdmin]="isAdmin"
                                        [key]="kv.key"
                                        [showTooltip]="true"
                                        [fieldType]="'pricing'"/>
                                 </span>
                            </td>
                            }
                        }
                        </tr>
                        }
                      </tbody>
                    </app-sortable-table>

                  </div>
                </div>
                <div class="d-lg-block d-none">
                  <table class="table dark-header table-last-row-no-border" style="table-layout: auto !important;">
                    <thead>
                    <tr>
                      <th class="more-th text-end width-50" [class.admin]="isAdmin">
                        @if (currentViewData?.options) {
                        <app-multiselect-dropdown [options]="currentViewData!.options" [ngModel]="currentViewData!.options"
                                               (ngModelChange)="onSelectedFieldsChange($event)"
                                               buttonIconClass="assets/icons/filter-icon-alt.svg" [iconSize]="24"
                                               [isTableHeading]="true" [isButton]="true"
                                               [iconClass]="'menu-icon--small'"/>
                        }
                      </th>
                    </tr>
                    </thead>
                    @if (isAdmin) {
                      <tr app-table-header-separator></tr>
                    }
                    <tbody>
                      @for (competitor of competitorViewData;track competitor;let idx = $index) {
                        <tr [ngStyle]="$last ? {'border-color': 'transparent'} : {}">
                          <td class="more-td text-end center-align width-50">
                            @if (isAdmin) {
                              <app-competitor-table-dropdown-actions-row
                                (chronometarRaceCompetitorStartStop)="onChronometarRaceCompetitorStartStop($event)"
                                (onEditCompetitorEventEmitter)="onEditCompetitor($event)"
                                (onEditTeamMemberButtonClick)="editTeamMemberButtonClick($event)"
                                (onDeleteCompetitorEventEmitter)="onDeleteCompetitor()"
                                [competitor]="competitors[idx]"
                                [event]="event" [index]="idx" [languages]="languages"
                                [isTeamMembersManagement]="isTeamMembersManagement" [measurements]="measurements"
                                [raceSettings]="competitors[idx].raceId ? raceSettingsMap.get(competitors[idx].raceId!) : undefined"
                                [raceAdditionalItems]="competitors[idx].raceId ? additionalPricingItemsMap.get(competitors[idx].raceId!) : []"
                                [raceCommercialItems]="competitors[idx].raceId ? commercialItemsMap.get(competitors[idx].raceId!) : []"
                                [applicationFormSettings]="competitors[idx].raceId ? applicationFormSettingsMap.get(competitors[idx].raceId!) : undefined"
                                [race]="race ?? (event?.racesList | getByField:'id':competitors[idx].raceId)"
                                />
                            } @else {
                              <div></div>
                            }

                          </td>
                        </tr>
                      }

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        } @else if (showEmptyState) {
          <div class="px-3 px-lg-4 pt-2">
            <app-empty-state [contentKeys]="['emptyState.not.able.to.find', 'emptyState.not.in.progress.try.later']"/>
          </div>
        }
      </div>
    }
  </div>

  <ng-template #competitorMobileItem let-competitor="competitor" let-isAdmin="isAdmin" let-last="last">
    <ng-container *ngIf="competitor | competitorMobileFields:competitor.raceId? viewDataHelper?.viewDataByRaceIds?.get(competitor.raceId!):undefined as fields">
        <div class="d-flex flex-column fs-14 grey-neutral-600 competitor-item-mobile" [class.last]="last">

            <!-- Name + Team -->
            @for (field of fields | filterArray:['fullName', 'teamName']; track field) {
            <div class="fw-bold pb-2">
              <app-competitor-field-output
                [competitor]="competitor" [isAdmin]="isAdmin"
                [key]="field"
                [fieldType]="'general'"/>
            </div>
            }

            <!-- Team Members -->
            @if (competitor.teamMembers?.length) {
            <div class="d-flex flex-wrap pb-2 fw-300">
              @for (member of competitor.teamMembers; track member) {
                <div class="member-item">
                <ng-container *ngIf="member | competitorMobileFields:competitor.raceId ? viewDataHelper?.viewDataByRaceIds?.get(competitor.raceId!)?.teamMemberView:undefined:true as memberFields">
                @for (memberField of memberFields; track memberField; let lastMemberField = $last) {
                <span class="text-uppercase">
                <app-competitor-field-output
                  [competitor]="member" [isAdmin]="isAdmin"
                  [key]="memberField"
                  [fieldType]="'general'"/>
              </span>
              <span class="pe-1">{{ lastMemberField ? '' : ',' }}</span>
            }
            </ng-container>
            </div>
            }
            </div>
            }

            <!-- Gender, Country, Club, Start Number -->
            <div class="d-flex flex-wrap align-items-center justify-content-start">
                @for (field of fields | filterArray:['startNumber', 'sex', 'country', 'club']; track field) {
                @if (competitor[field]) {
                <div class="field-item">
                  <app-competitor-field-output
                    [competitor]="competitor" [isAdmin]="isAdmin"
                    [key]="field"
                    [fieldType]="'general'"/>
                </div>
                }
                }
            </div>

            <!-- Payment & Category -->
            <div class="d-flex pt-2 align-items-center justify-content-start">
                @for (field of fields | filterArray:['paymentStatus', 'categoryLabel']; track field) {
                <div class="field-item">
                    @if (field === 'categoryLabel') {
                        <span>{{t('race.registration.settings.ageCategory')}} :</span>
                    }
                    <app-competitor-field-output
                    [competitor]="competitor" [isAdmin]="isAdmin"
                    [key]="field" [showAsPlain]="field !== 'paymentStatus'"
                    [fieldType]="'general'"/>
                 </div>
                }
            </div>
        </div>
    </ng-container>
  </ng-template>
</ng-container>

